import { IActivityHistoryItem } from "../domain/model";
import { Spec } from "../domain/specs/spec";

type Constructor<T> = new (...args: any[]) => T;

export enum ActivityHistoryFilterType {
  Switch = "switch",
  Checkbox = "checkbox",
  Dropdown = "dropdown",
}

export enum ActivityHistoryFilterOperation {
  And = "and",
  Or = "or",
}

export interface IActivityHistoryCommonFilterGroup {
  id: string;
  title: string;
  filters: IActivityHistoryCommonFilter[];
}

export interface IActivityHistoryCommonFilter {
  id: string;
  title: string;
  spec: Constructor<Spec<IActivityHistoryItem>>;
  enabled: boolean;
  type: ActivityHistoryFilterType;
}

export interface IActivityHistoryCustomFilterGroup {
  id: string;
  title: string;
  enabled: boolean;
  sort: string;
  filters: IActivityHistoryCustomFilter[];
}

export type IActivityHistoryFilter =
  | IActivityHistoryCommonFilterGroup
  | IActivityHistoryCustomFilterGroup
  | IActivityHistoryDiagnosticsFilter;

export interface IActivityHistoryCustomFilter {
  id: string;
  title: string;
  propPathValue: string[];
  propsPathDescription: string[];
  enabled: boolean;
  type: ActivityHistoryFilterType;
  singleOption?: boolean;
  options?: {
    id: string;
    title: string;
  }[];
  enabledValues?: string[];
}

export const isCommonFilterGroup = (group: IActivityHistoryFilter) => group.id === "common";
export const isNotCommonFilterGroup = (group: IActivityHistoryFilter) => !isCommonFilterGroup(group);
export const isDiagnosticFilter = (filter: IActivityHistoryFilter) => filter.id === diagnosticsfilterId;
export const isNotDiagnosticFilter = (filter: IActivityHistoryFilter) => !isDiagnosticFilter(filter);
export const isCustomFilter = (filter: IActivityHistoryFilter) =>
  !isCommonFilterGroup(filter) && !isDiagnosticFilter(filter) && !isUpFilter(filter);
export const isUpFilter = (filter: IActivityHistoryFilter) => filter.id === upFilterId;
export interface IActivityHistoryDiagnosticsFilter {
  id: string;
  title: string;
  values: { label: string; value: string }[];
  enabledValues: IDiagnosticWithRelations[];
}

// Nova estructura per diagnostics amb evolucions i relacions
export interface IDiagnosticRelation {
  codi: string;
  cataleg: string;
  nomCataleg: string;
  descripcio: string;
  idEcap: string;
  idCipds: string;
}

export interface IDiagnosticWithRelations extends IDiagnosticRelation {
  evolucions?: IDiagnosticRelation[];
  relacions?: IDiagnosticRelation[];
}

export interface ICiPdSDiagnosticFilter {
  diagnostics: IDiagnosticWithRelations[];
}

export interface IActivityHistoryUpFilter {
  id: string;
  title: string;
  values: { label: string; value: string }[];
  enabledValues: string[];
}

export const diagnosticsfilterId = "history-diagnostics";
export const relevantFilterId = "history-relevant";
export const ownFilterId = "history-own";
export const upFilterId = "history-up";
